$(function(){

	if(device == "pc"){
		var imageList = $('#Article .wrap .body li');
		var tmpTag = $('#Article .wrap .body li:first-child');
		$('#Article .wrap .body li').on('click',function(){
			
			$(imageList).removeClass('active');
			var $this = $(this);
			$this.addClass('active');
			var src = $this.find('img').attr('src');
			$("#Article .image.pc img").attr('src', src);
		});
	}else{
	
		var slick = $('#Article .wrap ul').slick({
			dots: false,
			arrows: true,
			nextArrow: '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-right.svg?v=1664364817" alt="→"></div>',
			prevArrow: '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0651/9963/6706/files/ico-top-left.svg?v=1664364831" alt="→"></div>',
			speed: 300,
			infinite: false,
			centerMode: true,
			centerPadding: '10px'
		});
		$('#Article .wrap ul').bind('touchstart', function(){
      return true;
    });
		$('#Article .wrap ul .slick-prev').css({'opacity':'0.2'});
		slick.on('beforeChange',function(event, slick, currentSlide, nextSlide){
			if(nextSlide == 0){
				$('#Article .wrap ul .slick-prev').css({'opacity':'0.2'});
			}else if(nextSlide == (slick.slideCount-1)){
				$('#Article .wrap ul .slick-next').css({'opacity':'0.2'});
			}else{
				$('#Article .wrap ul .slick-prev').css({'opacity':'1'});
				$('#Article .wrap ul .slick-next').css({'opacity':'1'});
			}
		});
	}

/*===================================================
						Window
=====================================================*/

//ページが読み込まれたら実行1
$(window).on('load',function() {
});

//ウィンドウリサイズしたら実行
$(window).on('resize',function() {
});

//スクロールしたら実行
$(window).on('scroll',function() {
});

});
